<template>
  <div class="d-flex show-timer align-items-center">
    <p class="secondary--text font-family-regular position-relative mr-4 mb-0">
      Timer
    </p>
    <div
      :class="[
        timerRunning ? 'timer-running-container' : 'timer-pause-container',
        'timer-container',
        'd-flex',
        'align-items-center'
      ]"
    >
      <img
        v-if="timerRunning"
        class="timer-clock-icon ml-4"
        src="@/assets/icons/timer_clock_active.svg"
        alt=""
      />
      <img
        v-else
        class="timer-clock-icon ml-4"
        src="@/assets/icons/timer_clock_pause.svg"
        alt=""
      />
      <p class="timer-display-time font-family-medium ml-3 mb-0 font-size-md">
        {{ timeText }}
      </p>
      <b-spinner v-if="timerLoading" class="timer-spinner" variant="primary" />
      <template v-else>
        <img
          v-b-tooltip.hover
          :title="tooltipText"
          v-if="timerRunning && validTaskTimer"
          @click="stopTimer"
          id="timer-stop-button"
          class="timer-action-btn"
          src="@/assets/icons/timer_resume.svg"
          alt=""
          data-cy="stop-timer-btn"
        />
        <img
          v-b-tooltip.hover
          :title="tooltipText"
          v-if="stopAt !== null && validTaskTimer"
          @click="startTimer"
          class="timer-action-btn"
          src="@/assets/icons/timer_pause.svg"
          alt=""
          data-cy="start-timer-btn"
        />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "TimerComponent",
  props: {
    timeText: null,
    selectedStatus: null,
    stopAt: null,
    selfTask: null,
    timerLoading: null,
    canUserOperateTimer: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  computed: {
    timerRunning() {
      return (
        this.timeText !== "00:00:00" &&
        this.stopAt === null &&
        this.selectedStatus !== "complete"
      );
    },
    tooltipText() {
      return this.canUserOperateTimer
        ? ""
        : "Only task owner or admin can update timer";
    },
    validTaskTimer() {
      return this.selfTask && this.selectedStatus !== "complete";
    }
  },
  methods: {
    stopTimer() {
      if (this.canUserOperateTimer) {
        this.$emit("stopTimer", this);
      }
    },
    startTimer() {
      if (this.canUserOperateTimer) {
        this.$emit("startTimer", this);
      }
    }
  }
};
</script>

<style lang="scss">
.show-timer .timer-container {
  border-radius: 28px;
  height: 45px;
  width: 18.5rem;
  overflow: hidden;
  padding: 0;
}

.show-timer .timer-running-container {
  background: #eceff4 !important;
  border: 1px solid #d4d4d4 !important;
}

.show-timer .timer-pause-container {
  background: #f3f5f8 !important;
  border: 1px solid #d4d4d4 !important;
}

.show-timer .timer-running-container .timer-display-time {
  color: #8f00ff !important;
  line-height: 1;
  flex: 1;
  position: static !important;
  top: auto !important;
}

.show-timer .timer-pause-container .timer-display-time {
  color: #849ba5 !important;
  line-height: 1;
  flex: 1;
  position: static !important;
  top: auto !important;
}

.show-timer .timer-action-btn {
  height: 45px;
  width: 45px;
  flex-shrink: 0;
  margin: 0;
  padding: 0;
  cursor: pointer;
  display: block;
}

.show-timer .timer-spinner {
  margin-left: auto;
  margin-right: 0.75rem;
}
</style>
